import Vue from "vue";

import { SelectSourceParams, SelectSourceServiceInterface } from "@share/common/types/interfaces/select-control/SelectSourceServiceInterface";
import { SelectObjectDataServiceInterface, SourceType } from "@share/common/types/interfaces/select-control/SelectDataService";

export class SelectDataService<T extends string> implements SelectObjectDataServiceInterface<T> {

    source: SourceType<T> = {};

    constructor(
        private selectSourceLoader: SelectSourceServiceInterface
    ) {

    }

    async updateSource(fieldName: T, params?: SelectSourceParams) {
        Vue.set(this.source, fieldName, await this.selectSourceLoader.getSelectSource(params))
    }
}